export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/918448516222"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat with us on WhatsApp"
      className="fixed left-4 bottom-24 md:bottom-6 z-40 inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1EBE5B] text-white font-semibold text-sm pl-3 pr-4 h-12 shadow-lg shadow-black/30 transition-colors"
    >
      <svg viewBox="0 0 32 32" className="w-6 h-6 fill-current" aria-hidden="true">
        <path d="M16.004 3C9.375 3 4 8.373 4 15c0 2.385.698 4.61 1.9 6.48L4 29l7.73-1.86A11.94 11.94 0 0 0 16.004 27C22.63 27 28 21.627 28 15S22.63 3 16.004 3zm0 21.8c-1.84 0-3.56-.5-5.04-1.37l-.36-.21-4.59 1.1 1.13-4.47-.24-.37A9.77 9.77 0 0 1 6.2 15c0-5.4 4.4-9.8 9.8-9.8s9.8 4.4 9.8 9.8-4.4 9.8-9.796 9.8zm5.38-7.34c-.29-.15-1.74-.86-2.01-.96-.27-.1-.47-.15-.66.15-.2.29-.76.96-.93 1.16-.17.2-.34.22-.64.07-.29-.15-1.24-.46-2.36-1.46-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.51-.07-.15-.66-1.6-.91-2.19-.24-.57-.48-.5-.66-.5h-.56c-.2 0-.51.07-.78.37-.27.29-1.02 1-1.02 2.44s1.05 2.83 1.2 3.03c.15.2 2.06 3.15 5 4.42.7.3 1.25.48 1.67.62.7.22 1.34.19 1.85.12.56-.08 1.74-.71 1.98-1.4.25-.69.25-1.28.17-1.4-.07-.12-.27-.2-.56-.34z" />
      </svg>
      Chat with us
    </a>
  );
}
